import { LiveCardItem } from "modules/live-carts/types"
import {
  LiveCardCreateBody,
  LiveCardDetailResponse,
} from "utils/api/client/types"

export class LiveCards {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: LiveCardCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: LiveCardItem }> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/carts`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: LiveCardCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<LiveCardItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/carts/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<LiveCardDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/carts/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/carts/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
